import { Route } from "react-router-dom";
import { DigiSignSingle } from "../Pages/DigitalSign";
import HomeLayout from "../themes/Home/HomeLayout";

const HomeRoutes = () => {
  return <Route path="/" element={<HomeLayout />}>
    <Route index element={<div>Welcome to the Home Page!</div>} />
    <Route index path="digital-sign"  element={<DigiSignSingle />} />
  </Route>
}


export default HomeRoutes;